import { render, staticRenderFns } from "./PerEvent.vue?vue&type=template&id=d3283cd0&"
import script from "./PerEvent.vue?vue&type=script&lang=js&"
export * from "./PerEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports